import useSWR from 'swr'
import { getFetcher } from '@BUP/services/Axios'
import { UtilsContext } from './utils-context.js'

export function UtilsProvider ({ children }) {
  const { data, isLoading, error } = useSWR('/utils', getFetcher, {
    errorRetryCount: 3,
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  })
  return (
    <UtilsContext.Provider value={{ data, isLoading, error }}>
      {children}
    </UtilsContext.Provider>
  )
}
